import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'

const Markdown = ({ data = '', isHyperlink = false, isPadding = false, isRichText = false, isMargin = false }) => {
  return isRichText ? (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ ...props }) => <a className={isHyperlink ? 'underline' : ''} {...props} />,
        p: ({ ...props }) => <h2 className={`${isPadding ? 'mb-4' : ''} ${isMargin ? 'mt-4' : ''}`} {...props} />,
        hr: ({ ...props }) => <hr className='my-4' {...props} />,
        ul: ({ ...props }) => <ul className="list-disc pl-4 pt-4" {...props} />,
        ol: ({ ...props }) => <ol className="list-decimal pl-4 pt-4" {...props} />,
        li: ({ ...props }) => <li className="list-disc pl-4 pt-4" {...props} />,
        strong: ({ ...props }) => <strong className="text-base" {...props} />,
      }}
    >
      {data}
    </ReactMarkdown>
  ) : (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ ...props }) => <a className={isHyperlink ? 'underline' : ''} {...props} />,
        p: ({ ...props }) => <h2 className={isPadding ? 'mb-4' : ''} {...props} />,
      }}
    >
      {data}
    </ReactMarkdown>
  )
}

export default Markdown
